'use client';

export async function loadBeacon (open = true, user) {
  if (window.Beacon) {
    if (open) window.Beacon('open')
    return
  }
  
  if (typeof window !== 'undefined' && window.location === window.parent.location) { // only on main site, not when embedded
    // Help Scout Beacon
    
    !function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
    window.Beacon('init', '8a5d44de-0bbd-4d5a-a7bd-3f6e0dba10d6')
    window.Beacon('config', {
      display: {
        style: 'manual',
        zIndex: 49
      }
    })
  }
      
  // whenever page is refreshed, set new user object in local storage
  if (user && user.id && window.Beacon) {
    let challengeCount
    let groupCount
    let groupsOwned
    if (user.challengesJoined && user.challengesJoined.length) {
      challengeCount = user.challengesJoined.length
    }
    if (user.groupsJoined && user.groupsJoined.length) {
      groupCount = user.groupsJoined.length
      if (user.organizationId) {
        const groups = user.groupsJoined.filter(g => g.organizationId === user.organizationId)
        if (groups.length) groupsOwned = groups.length
      }
    }
    window.Beacon('identify', {
      userId: user.id,
      name: user.fullname,
      email: user.email || undefined,
      avatar: user.photo || undefined,
      stravauserid: user.stravaUserId || undefined,
      facebookid: user.facebookId || undefined,
      organizationid: user.organizationId || undefined,
      challengecount: challengeCount,
      groupcount: groupCount,
      groupsowned: groupsOwned
    })
  }
  
  if (open) window.Beacon('open')
}

export async function openBeacon (id, user) {
  loadBeacon(false, user)
  window.Beacon('article', id)
}

export async function openForm (user) {
  loadBeacon(false, user)
  window.Beacon('open')
  window.Beacon('config', { mode: 'askFirst' })
  window.Beacon('navigate', '/ask/')
  window.Beacon('prefill', {
    userId: user.id,
    name: user.fullname,
    email: user.email || undefined,
    avatar: user.photo || undefined,
    subject: 'Add a Map'
  })
}
